import * as types from "./types";

export const getTotalAuditVsCompleteAudit = (data) => {
  return {
    type: types.TOTAL_AUDIT_VS_COMPLETE_AUDIT,
    payload: data,
  };
};

export const getTotalAuditVsCompleteAuditLoader = (data) => {
  return {
    type: types.TOTAL_AUDIT_VS_COMPLETE_AUDIT_LOADER,
    payload: data,
  };
};

export const getCountLevel = (data) => {
  return {
    type: types.COUNT_LEVEL,
    payload: data,
  };
};
export const getGradingGraph = (data) => {
  return {
    type: types.GRADING_GRAPH,
    payload: data,
  };
};

export const setAuditQuery = (query) => {
  return {
    type: types.SET_QUERY,
    payload: query,
  };
};

export const setRadarGraph = (data) => {
  return {
    type: types.RADAR_GRAPH,
    payload: data,
  };
};

export const setLevel2Graph = (data) => {
  return {
    type: types.LEVEL2,
    payload: data,
  };
};

export const setLevel3Graph = (data) => {
  return {
    type: types.LEVEL3,
    payload: data,
  };
};

export const setLevel4Graph = (data) => {
  return {
    type: types.LEVEL4,
    payload: data,
  };
};

export const setLevel5Graph = (data) => {
  return {
    type: types.LEVEL5,
    payload: data,
  };
};
